import { InjectionToken } from '@jack-henry/frontend-utils/di';

export type HttpResponse = Blob | ArrayBuffer | Response | string;
/**
 * Fetch signature as implemented by web browsers (contrasted with Node's version).
 */
export type BrowserFetch = Window['fetch'];
export type FetchFn = typeof fetch;

const g = globalThis;

export const FetchFnToken = new InjectionToken('FetchFunction', {
    value: g.fetch?.bind(g),
});
